import React, { useState } from 'react';
import { Grid, TextField, MenuItem, Alert, Typography, Divider } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";

export default function BancoPlazaForm({ amount, exchangeRate, onSubmit, isLoading, banksList }) {
    
    const prefixes = ['0412', '0422', '0414', '0416', '0424', '0426'];

    const [formData, setFormData] = useState({
        bank: '',
        phonePrefix: '414', 
        phoneNumber: '',
        reference: '',
        paymentDate: moment() // <-- NUEVO ESTADO: Fecha actual por defecto
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleDateChange = (newValue) => {
        setFormData({ ...formData, paymentDate: newValue });
    };

    const handleSubmit = () => {
        if (!formData.bank || !formData.phoneNumber || !formData.reference || !formData.paymentDate) {
            setError("Por favor completa todos los datos del pago.");
            return;
        }
        
        const amountBs = (amount * exchangeRate).toFixed(2);

        onSubmit({
            type: 'pago_movil',
            bank: formData.bank,
            phone: formData.phonePrefix + formData.phoneNumber,
            reference: formData.reference,
            amount_ves: amountBs,
            // Enviamos la fecha formateada correctamente para el backend (YYYY-MM-DD)
            payment_date: formData.paymentDate.format('YYYY-MM-DD') 
        });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                 <Alert severity="info" icon={false}>
                    <Typography>
                        Monto a pagar: <strong style={{fontSize:20}}>Bs. {(amount * exchangeRate).toFixed(2)} </strong> 
                        (Tasa: {exchangeRate})
                    </Typography>
                    <Typography variant='caption'>El monto debe ser exacto</Typography>
                 </Alert>
            </Grid>

            <Grid item xs={12}>
                <Typography fontWeight={'bold'}>Realizar el Pago móvil a los siguientes datos:</Typography>
                <Typography>*Banco: PLAZA (0138)</Typography>
                <Typography>*RIF: J-409546101</Typography>
                <Typography>*Teléfono: 04140850234</Typography>
            </Grid>

            <Grid item xs={12}>
                <Divider/>
            </Grid>
            
            <Grid item xs={12}>
                <Typography>Registre los datos del Pago móvil realizado:</Typography>
            </Grid>

            <Grid item xs={12}>
                <TextField
                    select 
                    fullWidth 
                    label="Banco Emisor" 
                    name="bank"
                    value={formData.bank} 
                    onChange={handleChange} 
                    size="small"
                    InputLabelProps={{ shrink: !!formData.bank || undefined }} 
                >
                    {/* Opción por defecto */}
                    <MenuItem value="">
                        <em>Seleccione el banco</em>
                    </MenuItem>

                    {banksList && banksList.map((bank) => {
                        // CORRECCIÓN: Usar uuid si existe, si no, code.
                        const bankValue = bank.uuid ? String(bank.uuid) : String(bank.code);
                        
                        return (
                            <MenuItem key={bankValue} value={bankValue}>
                                {bank.name}
                            </MenuItem>
                        );
                    })}
                </TextField>
            </Grid>

            <Grid item xs={4}>
                <TextField
                    select 
                    fullWidth 
                    label="Prefijo" 
                    name="phonePrefix"
                    value={formData.phonePrefix} 
                    onChange={handleChange} 
                    size="small"
                >
                    {prefixes.map(p => (
                        <MenuItem key={p} value={`${p.substring(1)}`}>
                            {p}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            
            <Grid item xs={8}>
                <TextField
                    fullWidth 
                    label="Teléfono" 
                    name="phoneNumber"
                    placeholder="1234567"
                    type="number"
                    value={formData.phoneNumber} 
                    onChange={handleChange} 
                    size="small"
                />
            </Grid>

            {/* --- FILA DE FECHA Y REFERENCIA --- */}
            <Grid item xs={5}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                        label="Fecha del pago"
                        inputFormat="DD/MM/YYYY"
                        // Opcional: minDate={new Date()} si quieres bloquear fechas pasadas
                        value={formData.paymentDate}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                    />
                </LocalizationProvider>
            </Grid>
            
            <Grid item xs={7}>
                <TextField
                    fullWidth 
                    label="Últimos 4 dígitos / Ref." 
                    name="reference"
                    value={formData.reference} 
                    onChange={handleChange} 
                    size="small"
                />
            </Grid>
            {/* ---------------------------------- */}
            
            {error && <Grid item xs={12}><Alert severity="error">{error}</Alert></Grid>}

            <Grid item xs={12}>
                <LoadingButton 
                    variant="contained" 
                    fullWidth 
                    loading={isLoading} 
                    onClick={handleSubmit}
                >
                    Procesar Pago Móvil
                </LoadingButton>
            </Grid>
        </Grid>
    );
}